import React, { useState, useRef, useMemo, useEffect } from 'react'
import { Model } from 'survey-core'
import { Survey } from 'survey-react-ui'
// import 'survey-core/defaultV2.min.css'

import { useConvertSurvey } from '../hooks/useConvertSurvey'
import { useSubmitAnswers } from '../hooks/useSubmitAnswers'
import 'survey-core/i18n/traditional-chinese'
import { useLoadProgress } from '../hooks/useLoadProgress'

const Agree = ({
  setAc,
  setTk,
  ac,
  tk,
  pid,
  setIsLoading,
  setCompletionMessage,
  // 暫存需加
  // userId,
}) => {
  const [myAgreeJson, setMyAgreeJson] = useState(null)
  // 需要登入嗎
  const requiresLogin = {
    // login: true,
    login: false,
    title: '驗證碼',
    placeholder: '請輸入驗證碼',
    alert: '請檢查網址是否帶入正確編號',
  }
  const [imagesReadingTime, setImagesReadingTime] = useState(0)
  const canShowPrevButtonPages = null
  const choicesOrderRef = useRef({})
  const choiceIndexMapRef = useRef({})
  const bringOptionsMapRef = useRef({})
  // 暫存需加
  // const [isReady, setIsReady] = useState(false)
  // const userIdRef = useRef(null)
  // useEffect(() => {
  //   if (userId) userIdRef.current = userId
  // }, [userId])
  // 防止閃閃
  useEffect(() => {
    const timeout = setTimeout(() => {
      const isMobile = window.innerWidth <= 576
      if (!isMobile) return

      const observer = new MutationObserver((mutationsList) => {
        for (let mutation of mutationsList) {
          if (mutation.type === 'childList') {
            const rootEl = document.querySelector('.sd-root-modern')
            if (
              rootEl &&
              !rootEl.classList.contains('sd-root-modern--mobile')
            ) {
              rootEl.classList.add('sd-root-modern--mobile')
              console.log('✅ 強制加上 mobile class 避免抖動')
            }
          }
        }
      })

      observer.observe(document.getElementById('root'), {
        childList: true,
        subtree: true,
      })

      // 清除
      return () => observer.disconnect()
    }, 100) // 100ms 後再判斷

    return () => clearTimeout(timeout)
  }, [])
  // 圖片閱讀時間(秒)
  // useEffect(() => {
  //   setImagesReadingTime(30)
  // }, [])
  const completedHtml = `<h3>問卷正在提交中，請稍候。</h3><h3>請在成功頁面顯示後再離開。</h3><h4>如有填卷相關問題請洽：</h4> <a href='https://lin.ee/HWETcqy'>https://lin.ee/HWETcqy</a><h4 style='margin-top:50px'>填寫其他問卷：</h4> <a href=${window.location.origin}>${window.location.origin}</a>`

  // eslint-disable-next-line react-hooks/exhaustive-deps
  const agreeSurvey = new Model(myAgreeJson)

  // 問卷編號
  // const pid = pid
  // 跳題 小心複選題要用陣列

  // const visibleIfConditionsInit = {
  //   q6: '{q5} = 0 or {q5} = 1 or {q5} = 2 or {q5} = 3',
  //   q7: '{q6} = ["none"]',
  //   q36: `{q35} <> ['none']`,
  // }

  const visibleIfConditionsInit = {
    q15: '{q14} = "other"',

    q43: '{q42} = 0 or {q42} = 1 or {q42} = 2 or {q42} = 3 or {q42} = 4',
    q44: '{q42} = 0 or {q42} = 1 or {q42} = 2 or {q42} = 3 or {q42} = 4',
    q45: '{q42} = 0 or {q42} = 1 or {q42} = 2 or {q42} = 3 or {q42} = 4',
    q46: '{q42} = 0 or {q42} = 1 or {q42} = 2 or {q42} = 3 or {q42} = 4',
    // 4-1
    q51: '{q50} = 1',
    q52: '{q50} = 2',
    q54: '{q53} = 1',
    q55: '{q53} = 2',
    q57: '{q56} = 1',
    q58: '{q56} = 2',
    q60: '{q59} = 1',
    q61: '{q59} = 2',
    q63: '{q62} = 1',
    q64: '{q62} = 2',
    q66: '{q65} = 1',
    q67: '{q65} = 2',
    q69: '{q68} = 1',
    q70: '{q68} = 2',
    q72: '{q71} = 1',
    q73: '{q71} = 2',
    q75: '{q74} = 1',
    q76: '{q74} = 2',
    q78: '{q77} = 1',
    q79: '{q77} = 2',
    q81: '{q80} = 1',
    q82: '{q80} = 2',
    // 5-6
    q94: '{q90} = 1 or {q90} = "other"',
    q95: '{q94} = 1',
    q96: '{q91} = 1 or {q91} = "other"',
    q97: '{q96} = 1',
  }
  // const visibleIfConditionsInit = null
  // const pageVisibleIfConditionsInit = null

  // 非必填(從 0 計算)
  // const notRequired = [100]
  const notRequired = null

  const mappedRateChoice = null
  // const pageBreakQuestions = ['q6', 'q11', 'q15']
  const pageBreakQuestions = null

  const triggersConditionsInit = [
    // {
    //   type: 'complete',
    //   expression: `({q0} = 1) or ({q1} = 1) or ({q2} = 0 or {q2} = 1)`,
    // },
  ]
  // const triggersConditionsInit = null
  // const pageVisibleIfConditionsInit = null
  // 帶出: 帶入
  const questionMappings = {
    // q20: 'q21',
  }

  const convertedSurvey = useConvertSurvey({
    survey: agreeSurvey,
    pid,
    setAc,
    setTk,
    ac,
    tk,
    setMyAgreeJson,
    imagesReadingTime,
    setImagesReadingTime,
    setIsLoading,
    completedHtml,
    visibleIfConditionsInit,
    notRequired,
    mappedRateChoice,
    pageBreakQuestions,
    requiresLogin,
    triggersConditionsInit,
    questionMappings,
    bringOptionsMapRef,
    // 暫存需加
    // userIdRef,
  })

  // const newSurvey = new Model(convertedSurvey)

  const surveyModel = useMemo(() => {
    if (!convertedSurvey) return null
    return new Model(convertedSurvey)
  }, [convertedSurvey])

  // 暫存需加
  // const otherAnswersRef = useRef({})
  // const noneAnswersRef = useRef({})
  // const matrixAnswersRef = useRef({})
  // const timestampsRef = useRef({})

  // 暫存需加
  // useLoadProgress({
  //   surveyModel: surveyModel, // 若 myAgreeJson 為 null，agreeSurvey 亦為 null
  //   convertedSurvey: myAgreeJson,
  //   isReady,
  //   requiresLogin,
  //   setIsLoading,
  //   pid,
  //   ac,
  //   tk,
  //   choiceIndexMapRef,
  //   choicesOrderRef,
  //   bringOptionsMapRef,
  //   otherAnswers: otherAnswersRef.current,
  //   noneAnswers: noneAnswersRef.current,
  //   matrixAnswers: matrixAnswersRef.current,
  //   timestamps: timestampsRef.current,
  // })

  // 暫存需加
  // SurveyModel 初始化完成 → 標記可互動
  // useEffect(() => {
  //   if (agreeSurvey) {
  //     const id = setTimeout(() => setIsReady(true), 50)
  //     return () => clearTimeout(id)
  //   }
  // }, [agreeSurvey])

  // // 設置 survey 準備就緒狀態
  // useEffect(() => {
  //   if (surveyModel) {
  //     // 給 survey 一些時間完成初始化
  //     setTimeout(() => {
  //       setIsReady(true)
  //     }, 50)
  //   }
  // }, [surveyModel])

  // 當 surveyModel 建立時，自動捲動到頂端
  useEffect(() => {
    if (surveyModel) {
      // 延遲執行以確保 DOM 已更新
      setTimeout(() => {
        // 捲動到頁面頂端
        window.scrollTo({
          top: 0,
          left: 0,
          behavior: 'instant', // 平滑捲動，也可以使用 'instant' 立即跳到頂端
        })

        // 或者也可以嘗試捲動問卷容器本身
        const surveyContainer = document.querySelector('.sd-root-modern')
        if (surveyContainer) {
          surveyContainer.scrollIntoView({ behavior: 'smooth', block: 'start' })
        }
      }, 100) // 給 DOM 一點時間完成渲染
    }
  }, [surveyModel])

  // useEffect(() => {
  //   console.log('convertedSurvey', convertedSurvey)
  // }, [convertedSurvey])

  const endMessage = `目前與您相同特性的樣本額滿，已停止收卷，可惜沒辦法繼續參與本次活動。如果覺得這個主題很有意思，非常歡迎您分享本問卷連結給親友，或是加入我們的<a href='https://lin.ee/HWETcqy'>LINE@</a>，隨時得到最新填問卷獲好禮的消息。<p>請按「完成」前往下載 EZChoice 或填寫更多問卷</p>`

  function helpFunction(survey, options) {
    // console.log('survey.getValue(q42)', survey.getValue('q42'))
    // 參考 P231113152849 或 P231101165555 或 P231206105643(政大帶入選項)
  }

  const endSurveyMsg = (survey) => {
    // if (
    //   survey.getValue('q0') === 1 ||
    //   survey.getValue('q1') === 1 ||
    //   survey.getValue('q2') === 0 ||
    //   survey.getValue('q2') === 1
    // ) {
    //   setCompletionMessage(endMessage)
    // } else {
    setCompletionMessage(
      `<div style="text-align:center;">問卷到此結束，感謝您的協助。</div>`
    )
    // }
  }

  // useEffect(() => {
  //   console.log('bringOptionsMapRef', bringOptionsMapRef)
  // }, [bringOptionsMapRef])

  useSubmitAnswers({
    survey: surveyModel,
    pid,
    ac,
    tk,
    imagesReadingTime,
    setIsLoading,
    helpFunction,
    canShowPrevButtonPages,
    choicesOrderRef,
    choiceIndexMapRef,
    endSurveyMsg,
    bringOptionsMapRef,
    // 暫存需加
    // requiresLogin,
    // userIdRef, // 傳入 ref 而不是直接傳 userId
    // enableProgressSaving: requiresLogin.login, // 根據登入需求啟用
  })

  return (
    <>
      {surveyModel ? (
        <Survey model={surveyModel} key={pid} />
      ) : myAgreeJson ? (
        <Survey model={agreeSurvey} />
      ) : (
        <></>
      )}
    </>
  )
}

export default Agree
